import React from 'react';
import { Provider } from 'react-redux';
import { getContext } from '@fiverr-private/fiverr_context';
import * as I18n from '../../../../NotificationsDrawer/lib/hoc';
import { SafeComponent } from '../../../../shared/SafeComponent';
import { REALTIME_NOTIFICATION_LOG_MODULE } from '../../../shared/constants';
import { Listener } from './components/Listener';
import { Favicon } from './components/Favicon';
import { createStore } from './store';
import { Toaster } from './components/Toaster';
import { tabManager } from './shared/tabManager';
import { SocketShape } from './propTypes';

class ToasterNotifications extends React.Component {
    constructor(props) {
        super(props);

        const thunkExtraProps = { tabManager };
        this.store = createStore(props, thunkExtraProps);
    }

    render() {
        const { socket } = this.props;
        const { locale } = getContext();

        return (
            <Provider store={this.store}>
                <I18n.Provider locale={locale}>
                    <>
                        <Listener socket={socket} tabManager={tabManager} />
                        <Toaster />
                        <Favicon />
                    </>
                </I18n.Provider>
            </Provider>
        );
    }
}

ToasterNotifications.propTypes = {
    socket: SocketShape,
};

export default SafeComponent(REALTIME_NOTIFICATION_LOG_MODULE, 'ToasterNotifications')(ToasterNotifications);
